import React, { createContext, useContext, useEffect, useState } from 'react';
import contentWrapperPromise from '../utils/ContentWrapper';

const ContentContext = createContext(null);

export function useContent() {
  return useContext(ContentContext);
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let isMounted = true;
    contentWrapperPromise.then(wrapper => {
      if (isMounted) setContent(wrapper);
    });
    return () => { isMounted = false; };
  }, []);

  if (!content) {
    return <div>Loading site content...</div>; // or a splash screen
  }

  return (
    <ContentContext.Provider value={content}>
      {children}
    </ContentContext.Provider>
  );
}
